import { compareDateStrings } from '../../generic-utils/dateUtils.esm.js';
import dateUtils from './dateUtils.esm.js';

var getToday = function () {
    var date = new Date();
    return {
        day: date.getDate(),
        month: date.getMonth(),
        year: date.getFullYear()
    };
};
var getMaxDate = function (maxDate) {
    if (maxDate) {
        return {
            day: maxDate.getDate(),
            month: maxDate.getMonth(),
            year: maxDate.getFullYear()
        };
    }
    return undefined;
};
var isToday = function (day, today) {
    return day.day === today.day && day.month === today.month && day.year === today.year;
};
var isPast = function (day, today) {
    return compareDateStrings(dateUtils.getDayToString(day), dateUtils.getDayToString(today)) > 0;
};
var isAfter = function (day, today) {
    return compareDateStrings(dateUtils.getDayToString(day), dateUtils.getDayToString(today)) < 0;
};
var todayUtil = { getToday: getToday, getMaxDate: getMaxDate, isToday: isToday, isPast: isPast, isAfter: isAfter };

export { todayUtil as default };
